// hooks/useFormatPrice.ts

import { formatCurrency } from "@repo/ui/lib/utils";

import { useAppSelector } from "@repo/store/hooks";
import { selectCurrency, selectLocale, useManageBooking } from "@repo/store/slices";

import { getLocaleFromCurrency } from "../../../locale/src/locales";

/**
 * Provides a function to format prices with the current locale.
 * Currency need to get from store (TODO)
 */
export function useFormatPrice() {
  let locale = useAppSelector(selectLocale);
  const bookingSummary = useManageBooking();

  const bookingInstanceCurrency = bookingSummary?.currencyCode;

  // Currency should retain booking instate currecy code
  if (bookingInstanceCurrency) {
    locale = getLocaleFromCurrency(bookingInstanceCurrency);
  }

  const selectedCurrency = useAppSelector(selectCurrency);
  const currency = bookingInstanceCurrency ?? selectedCurrency;

  // const currency = getCurrencyFromLocale(locale); //TODO need to get from cookies this is used to get default value

  return (value: number | string) => {
    return formatCurrency(Number(value), currency, locale);
  };
}
